import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            applicationsReceived: 'applications/Applications',
            applicationAttachmentsReceived: 'applications/ApplicationAttachments',
        }),
    },
    methods: {
        ...mapActions({
            FetchApplications: 'applications/FetchApplications',
            FetchApplicationAttachmentsByAcademicSession: 'applications/FetchApplicationAttachmentsByAcademicSession',
        }),
        LoadApplications() {
            eventBus.$emit('applications-fetch:started');
            this.FetchApplications({ KeycloakID: this.KeycloakID })
                .then(() => {
                    this.applications = [...this.applicationsReceived];
                    eventBus.$emit('applications-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('applications-fetch:finished'));
        },
        LoadApplicationAttachmentsByAcademicSession(academicSession) {
            eventBus.$emit('application-attachments-fetch:started');
            this.FetchApplicationAttachmentsByAcademicSession({ AcademicSession: academicSession })
                .then(() => {
                    this.applicationAttachments = [...this.applicationAttachmentsReceived];
                    eventBus.$emit('application-attachments-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('application-attachments-fetch:finished'));
        },
        GetApplicationStatusColor(status) {
            switch (status) {
                case 'Funding Not Requested': return 'error';
                case 'Unsubmitted': return 'warning';
                default: return 'info';
            }
        }
    },
};